import { z } from 'zod';

import type { FieldConfig } from '@/types/forms';
import { createEnquirySchema } from '@/lib/forms/schemas/enquirySchema';

export const UrologyPackagesEnquirySchema = createEnquirySchema({
  includePreferredContact: false,
});

export type UrologyPackagesEnquiryValues = z.infer<
  typeof UrologyPackagesEnquirySchema
>;

export const urologyPackagesEnquiryDefaultValues: UrologyPackagesEnquiryValues =
  {
    fullName: '',
    email: '',
    phone: '',
    preferredContact: undefined,
    message: '',
  };

export const urologyPackagesEnquiryFields: FieldConfig[] = [
  {
    name: 'fullName',
    type: 'text',
    label: 'Full Name',
    placeholder: 'Enter your full name',
    required: true,
  },
  {
    name: 'email',
    type: 'email',
    label: 'Email Address',
    placeholder: 'Enter your email address',
    required: true,
  },
  {
    name: 'phone',
    type: 'tel',
    label: 'Phone Number',
    placeholder: 'Enter your phone number',
    required: true,
  },
  {
    name: 'message',
    type: 'textarea',
    label: 'Message',
    placeholder: 'How can we help?',
    required: true,
    rows: 5,
    fullWidth: true,
  },
];
